/**
 * =========================================================
 * jc-accordion.js
 * ---------------------------------------------------------
 * 2026-02-17 17:51にFAQページでアコーディオンが動作しないためソースコードを修正（FUKU）
 * 用途:
 *  - 「よくある質問（FAQ）」用のアコーディオン開閉制御
 *  - /pages/frequently-asked-questions と
 *    ブログ記事・固定コンテンツ内に挿入したFAQを
 *    同一の挙動で動かすための共通スクリプト
 *
 * 背景:
 *  - Shopifyでは、ブログ本文 / RTE / Custom Fields 内の
 *    <script> が無効化・削除されることがある
 *  - そのため、FAQの開閉ロジックは assets に集約し、
 *    ページ種別に依存せず動くようにする必要がある
 *
 * 対象DOM構造（既存FAQを踏襲）:
 *  <div class="accordion">
 *    <div class="accordion-item">
 *      <div class="accordion-title js-accordion-trigger">
 *        <span class="accordion-label">Q....</span>
 *        <span class="accordion-icon">＋</span>
 *      </div>
 *      <div class="accordion-content">A....</div>
 *    </div>
 *  </div>
 *
 * 実装方針:
 *  - イベントデリゲーション方式
 *    （後からDOMに追加されても動く）
 *  - .accordion 内だけを対象にして誤爆を防止
 *  - CSSアニメーション等は使わず、display制御のみ
 *
 * 注意:
 *  - 「1つ開いたら他を閉じる」仕様にはしていない
 *    （FAQページ既存挙動を尊重）
 *  - 変更する場合は、ここを共通仕様として調整する
 * =========================================================
 */

(function () {
  function onAccordionClick(e) {
    var trigger = e.target.closest && e.target.closest('.js-accordion-trigger');
    if (trigger) {
      var accordion = trigger.closest('.accordion');
      if (accordion) {
        var content = trigger.nextElementSibling;
        if (content && content.classList.contains('accordion-content')) {
          var icon = trigger.querySelector('.accordion-icon');
          var isOpen = content.style.display === 'block';
          if (isOpen) {
            content.style.display = 'none';
            trigger.style.fontWeight = '600';
            if (icon) icon.textContent = '＋';
          } else {
            content.style.display = 'block';
            trigger.style.fontWeight = '700';
            if (icon) icon.textContent = '－';
          }
        }
      }
    }
  }
  document.addEventListener('click', onAccordionClick, false);
})();